
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]/specials",
      function () {
        return require("private-next-pages/dispensary/[cName]/specials/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]/specials"])
      });
    }
  